
import { Component, Mixins, Prop } from "vue-property-decorator"
import uniqueIdMixin from "@/mixins/uniqueIdMixin"

/**
 * The help icon displays an icon with a popover containing the text specified in the default slot
 * You can optionally display a using the help-title prop
 */
@Component({})
export default class HelpIcon extends Mixins(uniqueIdMixin) {
	@Prop({ type: String, default: "" }) helpTitle!: string

	@Prop({ type: String, default: "" }) htmlHelpText!: string

	@Prop({ type: String, default: "info" }) variant!: string

	private get iconId (): string {
		return `help-icon-${this.uniqueId}`
	}

	private get textStyleClass (): string {
		return `text-${this.variant}`
	}
}
